import React, { createContext, useState, useContext } from 'react';

// Create the User Context
export const UserContext = createContext();

// Create the User Context Provider
export const UserProvider = ({ children }) => {
    const [paying, setPay] = useState(null);
    const [returnUrl, setReturnUrl] = useState(null);
    const [showSuccess, setShowSuccess] = useState(false);
    const setPaying = (pay) => {
        setPay(pay);
    };
    return (
        <UserContext.Provider value={{ paying, setPaying, returnUrl, setReturnUrl, setShowSuccess, showSuccess }}>
            {children}
        </UserContext.Provider>
    );
};

// Custom hook to use the UserContext
export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};